import openSocket from "socket.io-client";
import { isObject } from "lodash";
import SocketWorker from "./SocketWorker"

// =====================================================================
// socket.js (S40 fix #69 — bidirectional caller bug)
//
// HISTORICO:
// - S39: SocketWorker tinha bug singleton stale token=undefined
// - S40 deploy 28/05 ~00:55: fix singleton funcionou MAS revelou
//   bug latente nos callers que passavam params no formato errado.
//
// BUG DETECTADO POS-DEPLOY S40 28/05 ~01:15:
//   Logs backend: "CompanyId do token 1 diferente da companyId do socket undefined"
//   Causa: 3 dos 4 callers passam params no formato { companyId, userId }
//   mas socketConnection so leia de params.user.companyId/id.
//   Resultado: companyId=undefined no constructor SocketWorker →
//   URL "/undefined" no namespace → backend rejeita →
//   handler "io server disconnect" reconecta automaticamente → loop infinito.
//
// CALLERS COM FORMATO INCONSISTENTE (todos os 4 mantidos compativeis):
//   useAuth.js:97       → socketConnection({ user: { companyId, id } })  CORRETO
//   Status/index.js:444 → socketConnection({ companyId })                BUGADO
//   Chat/index.js:346   → socketConnection({ companyId, userId })        BUGADO
//   ChatPopover.js:152  → socketConnection({ companyId, userId })        BUGADO
//
// FIX:
//   1. Aceita AMBOS formatos: { user: {...} } OU { companyId, userId }
//   2. Guard: se companyId ainda undefined apos extracao, RETORNA null
//      em vez de criar SocketWorker zumbi
//   3. Caller deve verificar return (alguns ja fazem: if (socketInstance))
// =====================================================================

export function socketConnection(params) {
  let userId = "";
  let companyId = "";

  if (isObject(params)) {
    // S40 #69: aceitar AMBOS formatos pra compatibilidade
    //   formato 1 (useAuth): { user: { companyId, id } }
    //   formato 2 (Status, Chat, ChatPopover): { companyId, userId }
    companyId = params?.user?.companyId || params?.companyId;
    userId = params?.user?.id || params?.userId;
  }

  // S40 #69: GUARD critico — sem companyId, URL vira "/undefined"
  // e gera loop "io server disconnect".
  //
  // RETORNA STUB ao inves de null pra evitar CRASH em callers que nao
  // verificam null antes de .on() (ex: ChatPopover.js:152 nao checa retorno).
  // Stub e safe: .on()/.emit() sao no-op, sem efeito colateral.
  if (!companyId) {
    console.warn(
      "[socketConnection] companyId ausente — retornando STUB (no-op). " +
        "Params recebidos: " + (typeof params === "object" ? JSON.stringify(Object.keys(params || {})) : typeof params)
    );
    return {
      on: () => {},
      emit: () => {},
      off: () => {},
      disconnect: () => {},
      connect: () => {},
      forceReconnect: () => {}
    };
  }

  return SocketWorker(companyId, userId);
}
